export default __webpack_public_path__ + "static/media/4_2.0827a5ee.png";